export const enum EInsuranceStatus {
  ACTIVE = 'active',
  FINISHED = 'finished',
  // Within claims period is a status that is only used in the frontend
  // to determine if the user can claim the insurance or not.
  // if meta claim_until is before the current date, the status will be within_claim_period
  // in backend, the status will be finished
  WITHIN_CLAIM_PERIOD = 'within_claim_period',
}
